<template>
    <div
        class="statsCard ppv2-group ppv2-relative ppv2-flex ppv2-items-center ppv2-rounded-xl ppv2-cursor-pointer ppv2-transition-all ppv2-duration-200"
        :style="{
            gap: normalizeSize(16, true),
            paddingLeft: normalizeSize(24, true),
            paddingRight: normalizeSize(24, true),
            paddingTop: normalizeSize(14, true),
            paddingBottom: normalizeSize(14, true),
        }"
        :class="[
            isActive
                ? 'statsCardActive ppv2-bg-white dark:ppv2-bg-dark'
                : 'ppv2-border ppv2-border-white/20 hover:ppv2-bg-white/5',
        ]"
        @click="$emit('click')"
    >
        <!-- Icon Container -->
        <div
            class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-w-[50px] ppv2-h-[50px] ppv2-rounded-xl ppv2-transition-colors ppv2-duration-200"
            :class="[isActive ? '' : 'ppv2-bg-white/10']"
        >
            <component
                :is="icon"
                :size="24"
                class="ppv2-transition-colors ppv2-duration-200"
                :class="isActive ? '' : 'ppv2-text-white'"
            />
        </div>

        <!-- Text Content -->
        <div class="ppv2-flex ppv2-flex-col">
            <span
                class="ppv2-text-2xl poppinsBold ppv2-leading-none"
                :class="[isActive ? 'ppv2-text-black' : 'ppv2-text-white', label ? 'ppv2-mb-1' : '']"
            >
                {{ displayCount }}
            </span>
            <span
                v-if="label"
                class="ppv2-text-sm poppinsMedium ppv2-leading-tight"
                :class="isActive ? 'ppv2-text-black' : 'ppv2-text-white'"
            >
                {{ label }}
            </span>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

export default {
    name: 'StatsCard',
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        count: {
            type: [Number, String],
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        icon: {
            type: [Object, String],
            required: true,
        },
    },
    data() {
        return {
            displayCount: 0,
            animationFrame: null,
        }
    },
    watch: {
        count: {
            immediate: true,
            handler(newVal) {
                this.animateCount(newVal)
            },
        },
    },
    methods: {
        normalizeSize,
        animateCount(targetValue) {
            const start = this.displayCount
            const end = parseInt(targetValue) || 0
            if (start === end) return

            const duration = 1500 // 1,5 second
            const startTime = performance.now()

            const animate = (currentTime) => {
                const elapsed = currentTime - startTime
                const progress = Math.min(elapsed / duration, 1)

                // Ease out quart
                const ease = 1 - Math.pow(1 - progress, 4)

                this.displayCount = Math.floor(start + (end - start) * ease)

                if (progress < 1) {
                    this.animationFrame = requestAnimationFrame(animate)
                } else {
                    this.displayCount = end
                }
            }

            if (this.animationFrame) {
                cancelAnimationFrame(this.animationFrame)
            }
            this.animationFrame = requestAnimationFrame(animate)
        },
    },
    beforeDestroy() {
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame)
        }
    },
}
</script>

<style scoped lang="scss">
// Rapatrié depuis Food/index.vue : la card active doit être blanche sur toutes les pages
// qui montent FoodStatsNavigation (Catalogue et Mouvements de stock).
.statsCard {
    background: transparent;
    border: 2px solid rgba(255, 255, 255, 0.35);
    min-width: 180px;
    flex: 1;
}

.statsCardActive {
    background: white !important;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
</style>
